import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { StorageRootDto } from "../StorageRootDto";
import { MonitorPolicy } from "../../DiscoveryEngine.TS/Monitors/MonitorPolicy";


export class AgentMonitorPolicyDto extends StorageRootDto {

	public UserGuid: string;
	public ScopeGuid: string;
	public AgentGuid: string;
	public MonitorPolicy: MonitorPolicy;

	constructor() {
		super();

		this.UserGuid = "";
		this.ScopeGuid = "";
		this.AgentGuid = "";
		this.MonitorPolicy = null;
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasScopeGuid(): boolean {
		return !!this.ScopeGuid;
	}

	public get HasAgentGuid(): boolean {
		return !!this.AgentGuid;
	}

	public get HasMonitorPolicy(): boolean {
		return !!this.MonitorPolicy;
	}

	public Write(obj: any, context: any): void {
		obj.agent_monitor_policy = {};
		obj = obj.agent_monitor_policy;

		super.Write(obj, context);

		if (this.HasUserGuid)
			obj.user_guid = this.UserGuid;

		if (this.HasScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		if (this.HasAgentGuid)
			obj.agent_guid = this.AgentGuid;

		if (this.HasMonitorPolicy)
			this.MonitorPolicy.Write(obj, context);
	}

	public Read(obj: any, context: any): void {

		if (!obj.agent_monitor_policy)
			throw new Error();
		obj = obj.agent_monitor_policy;

		super.Read(obj, context);

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.agent_guid !== undefined)
			this.AgentGuid = obj.agent_guid;

		if (obj.monitor_policy !== undefined) {
			this.MonitorPolicy = new MonitorPolicy();
			this.MonitorPolicy.Read(obj, context);
		}
	}

}